import { tv, VariantProps } from '@/utils/tv'

export const helpText = tv({
  slots: {
    base: ['flex gap-1.5', 'text-body-sm'],
    icon: ['w-3 h-3', 'mt-0.5', 'outline-none']
  },
  variants: {
    status: {
      default: {
        base: ''
      },
      success: {
        base: 'text-green-500'
      },
      danger: {
        base: 'text-red-500'
      }
    },
    floating: {
      false: 'mt-2',
      true: 'absolute top-full translate-y-1'
    }
  },
  defaultVariants: {
    status: 'default',
    floating: false
  }
})

export type HelpTextVariantProps = VariantProps<typeof helpText>
